// extracted by mini-css-extract-plugin
export var contactDepartmentAddressBlock = "departmentAddress-module--contactDepartmentAddressBlock--3fd9e";
export var lightColor = "departmentAddress-module--lightColor--d8beb";